export default {
      id: "right-caret-usage",
      viewBox: "0 0 32 32",
      url: __webpack_public_path__ + "sprite.svg#right-caret",
      toString: function () {
        return this.url;
      }
    }